import type { TOC } from '@ember/component/template-only';
import { formatDurationMs, joinList, releaseYear } from '../../utils/format';

interface Signature {
  Args: { data: Record<string, unknown> | null | undefined };
}

const MusicDetail: TOC<Signature> = <template>
  {{#let (asMusicData @data) as |d|}}
    <div class="flex flex-col gap-3">
      {{#if d.artists.length}}
        <p class="text-base-content/80 text-sm font-medium">
          {{joinList d.artists}}
        </p>
      {{/if}}

      {{#if d.albumName}}
        <p class="text-base-content/60 text-sm">
          Album:
          {{d.albumName}}
        </p>
      {{/if}}

      <div class="flex flex-wrap gap-2">
        {{#if d.releaseDate}}
          <span class="badge badge-outline">{{releaseYear d.releaseDate}}</span>
        {{/if}}
        {{#if d.duration}}
          <span class="badge badge-ghost">{{formatDurationMs d.duration}}</span>
        {{/if}}
        {{#if d.type}}
          <span
            class="badge badge-primary badge-sm capitalize"
          >{{d.type}}</span>
        {{/if}}
        {{#each d.genres as |genre|}}
          <span class="badge badge-ghost badge-sm">{{genre}}</span>
        {{/each}}
      </div>

      {{#if d.externalUrl}}
        <div>
          <a
            href={{d.externalUrl}}
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn-xs gap-1 border-[#1DB954] bg-[#1DB954] text-white hover:border-[#17a349] hover:bg-[#17a349]"
          >
            Open on Spotify ↗
          </a>
        </div>
      {{/if}}
    </div>
  {{/let}}
</template>;

interface MusicData {
  name?: string;
  artists?: string[];
  albumName?: string;
  releaseDate?: string;
  artworkUrl?: string;
  duration?: number;
  genres?: string[];
  type?: string;
  externalUrl?: string;
}

function asMusicData(
  raw: Record<string, unknown> | null | undefined
): MusicData {
  const d = (raw ?? {}) as MusicData;
  d.artists = d.artists ?? [];
  d.genres = d.genres ?? [];
  return d;
}

export default MusicDetail;
